import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { SpdrClientViewModel } from "../../../../ViewModel/SpdrClientViewModel";
import { isRoutingTableChanged } from "./IsRoutingTableChanged";
import { getSPD } from "./GetSPD";
import { isSpdrOrPdsrChanged } from "./IsSpdrOrPdsrChanged";

export function areRoutesChanged(
  selectedSpdrId: number | undefined,
  ftlRoutes: Array<FtlRouteViewModel> | undefined,
  templateFtlRoutes: Array<FtlRouteViewModel> | undefined
) {
  if (!selectedSpdrId || !ftlRoutes || !templateFtlRoutes) {
    return false;
  }

  const { supplier, plant, dock } = getSPD(selectedSpdrId, ftlRoutes);

  const ftlRoutesWithSelectedSpdr = ftlRoutes.filter((r) =>
    r.SpdrsOnThisRoute?.filter((s) => s.SpdrId === selectedSpdrId)
  );

  const templateFtlRoutesWithSelectedSpdr = templateFtlRoutes.filter((r) =>
    r.SpdrsOnThisRoute?.filter(
      (s) =>
        s.SupplierGsdb === supplier &&
        s.PlantGsdb === plant &&
        s.DockCode === dock
    )
  );

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ftlRoutesWithSelectedSpdr.length; i++) {
    const templateRouteWithSpdr = templateFtlRoutesWithSelectedSpdr.find(
      (r) => r.RouteNumber === ftlRoutesWithSelectedSpdr[i].RouteNumber
    );

    const templateSpdr: SpdrClientViewModel | undefined =
      templateRouteWithSpdr?.SpdrsOnThisRoute?.find(
        (s) =>
          s.SupplierGsdb === supplier &&
          s.PlantGsdb === plant &&
          s.DockCode === dock
      );

    const spdr: SpdrClientViewModel | undefined = ftlRoutesWithSelectedSpdr[
      i
    ]?.SpdrsOnThisRoute?.find((s) => s.SpdrId === selectedSpdrId);

    if (!templateSpdr || !spdr) {
      return true;
    }

    if (
      isSpdrOrPdsrChanged(templateSpdr, spdr) ||
      isRoutingTableChanged(
        templateRouteWithSpdr?.RoutingTable,
        ftlRoutesWithSelectedSpdr[i].RoutingTable
      )
    ) {
      return true;
    }
  }

  return false;
}
